import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import Loader from "../../components/Loader/Loader";
import HeaderOne from "../../components/Header/HeaderOne";
import FooterOne from "../../components/Footer/FooterOne";



const ResponsiveIframe = () => {
  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);
  return (
    <Loader>
      <HeaderOne  />
      <section className="">
       <br />
      <div style={{ position: 'relative', paddingBottom: '75.25%', height: 0 }}>
    <iframe
      src={`${process.env.REACT_APP_IFRAME_BASE_URL}marketreportFRAME.php`}
      title="OLSHAN LUXURY MARKET REPORT"
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        border: 0
      }}
      allowFullScreen
    />
  </div>

    
    </section>


      <FooterOne />
    </Loader>
  );
};



export default ResponsiveIframe;










